"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
//@ts-ignore
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const option_1 = require("../option");
const CheckBox_1 = require("./CheckBox");
const Icon_1 = __importDefault(require("./Icon"));
exports.DropDown = react_1.default.memo(({ noShowButtonArea = false, className, value, list, styles, option, isDisable = false, setDropValue, isHeaderTitle = false, setMenuOpen, excludeList, isSidebar, multiSelect = false, selectedList, setSelectedList, showCheckbox = false, renderTitleText, closeOnSelect, fixedList = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dropDownRef = (0, react_1.useRef)(null);
    const dropDownChildRef = (0, react_1.useRef)(null);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [dropItem, setDropItem] = (0, react_1.useState)(value);
    const [dropItems, setDropItems] = (0, react_1.useState)(selectedList || []);
    const multiSelectedItems = multiSelect ? selectedList || dropItems : [];
    const { isDesktop, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    (0, react_1.useEffect)(() => {
        if (dropItem?.id !== value?.id)
            setDropItem(value);
    }, [value]);
    (0, react_1.useEffect)(() => {
        if (!multiSelect)
            return;
        setDropItems(selectedList || []);
    }, [multiSelect, selectedList]);
    const dropOption = (0, react_1.useMemo)(() => lodash_1.default.merge({}, option_1.DropDownOption, option), [option]);
    const handlerDropDownClick = () => {
        if (noShowButtonArea) {
            const dropdownContent = dropDownRef.current;
            const dropdownChild = dropDownChildRef.current;
            if (dropdownContent && dropdownChild) {
                // 드롭다운을 표시 상태로 설정
                dropdownChild.style.display = 'block'; // 드롭다운을 표시 상태로 변경
                const parentRect = dropdownContent.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                const dropdownHeight = dropdownChild.offsetHeight;
                // 드롭다운의 위치를 초기화
                dropdownChild.style.position = 'fixed';
                // 열린 오버레이는 sticky/fixed 바(버튼 바 z-index:3 등)보다 항상 위에 그려져야 함
                dropdownChild.style.zIndex = '1000';
                dropdownChild.style.top = 'auto';
                dropdownChild.style.bottom = 'auto';
                // 드롭다운이 아래로 넘치면 위로 표시
                if (parentRect.bottom + dropdownHeight > viewportHeight) {
                    dropdownChild.style.bottom = `${viewportHeight - parentRect.top + 30}px`;
                    dropdownChild.style.top = 'auto';
                }
                else {
                    // 그 외의 경우는 아래로 표시
                    dropdownChild.style.top = `${parentRect.bottom}px`;
                    dropdownChild.style.bottom = 'auto';
                }
                dropdownChild.style.left = `${parentRect.left}px`;
            }
            // 드롭다운을 숨김 상태로 되돌리기
            dropdownChild.style.display = ''; // 기본 상태로 변경
            const parentRect = dropdownContent?.getBoundingClientRect();
            dropdownChild.style.width = !isHeaderTitle ? ` ${parentRect.width}px` : undefined;
            setOpen(!open);
        }
        else {
            const dropdownContent = dropDownRef.current;
            if (dropdownContent) {
                const dropChild = dropDownChildRef.current;
                const parentRect = dropdownContent.getBoundingClientRect();
                if (dropChild) {
                    dropChild.style.width = !isHeaderTitle
                        ? `${parentRect.width}px`
                        : undefined;
                    dropChild.style.display = 'flex';
                    const dropdownHeight = dropChild.offsetHeight;
                    dropChild.style.display = '';
                    const viewportHeight = window.innerHeight;
                    if (fixedList) {
                        // 상위 overflow 클리핑/낮은 z-index 가림 회피: viewport 기준 fixed 배치
                        dropChild.style.position = 'fixed';
                        dropChild.style.left = `${parentRect.left}px`;
                        dropChild.style.zIndex = '1000';
                        if (parentRect.bottom + dropdownHeight > viewportHeight) {
                            dropChild.style.top = 'auto';
                            dropChild.style.bottom = `${viewportHeight - parentRect.top + 10}px`;
                        }
                        else {
                            dropChild.style.top = `${parentRect.bottom}px`;
                            dropChild.style.bottom = 'auto';
                        }
                    }
                    else {
                        // position(absolute)/기하는 SCSS 기본 유지, stacking 만 정합:
                        // 열린 오버레이가 sticky/fixed 바(버튼 바 z-index:3 등) 뒤로 깔리지 않도록 z-index 통일
                        dropChild.style.zIndex = '1000';
                        if (parentRect.bottom + dropdownHeight > viewportHeight) {
                            dropChild.style.top = 'auto';
                            dropChild.style.bottom = `${parentRect.height + 10}px`;
                        }
                        else {
                            dropChild.style.top = `${parentRect.height + 10}px`;
                            dropChild.style.bottom = 'auto';
                        }
                    }
                }
            }
            setOpen(!open);
        }
    };
    const handleClickOutside = (event) => {
        const dropdownContent = dropDownRef.current;
        if (dropdownContent && !dropdownContent.contains(event.target)) {
            setOpen(false);
        }
    };
    const handleResize = () => setOpen(false);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('scroll', handleResize);
        window.addEventListener('click', handleClickOutside);
        return () => {
            APP.eventManager.unsubscribe('scroll', handleResize);
            window.removeEventListener('click', handleClickOutside);
        };
    }, []);
    const handlerItemClick = (item) => {
        if (multiSelect) {
            const isSelected = multiSelectedItems.some(selectedItem => selectedItem.id === item.id);
            const nextItems = isSelected
                ? multiSelectedItems.filter(selectedItem => selectedItem.id !== item.id)
                : [...multiSelectedItems, item];
            setDropItems(nextItems);
            setSelectedList && setSelectedList(nextItems);
            if (closeOnSelect === true) {
                setOpen(false);
            }
            return;
        }
        setDropValue(item);
        setDropItem(item);
        setOpen(closeOnSelect === false);
    };
    (0, react_1.useEffect)(() => {
        if (!setMenuOpen)
            return;
        setMenuOpen(open);
    }, [open]);
    /**
     * (Component) Select Title
     */
    const renderTitle = (0, react_1.useMemo)(() => {
        const titleText = multiSelect
            ? renderTitleText
                ? renderTitleText(multiSelectedItems, list)
                : multiSelectedItems.map(item => t(`${item.title}`)).join(', ')
            : t(`${dropItem?.title}`);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            dropOption.titleIcon.show && (react_1.default.createElement(Icon_1.default, { icon: dropOption.titleIcon.name, size: dropOption.titleIcon.size, fill: dropOption.titleIcon.color })),
            !isHeaderTitle && (react_1.default.createElement("p", { className: "placeholder overText", style: { flex: 1, ...styles?.titleText } }, titleText))));
    }, [dropItem, dropOption.titleIcon, isHeaderTitle, list, multiSelect, multiSelectedItems, renderTitleText, styles?.titleText, t]);
    const renderItem = (item, index) => {
        if (excludeList && excludeList.includes(item.id))
            return null;
        const selected = multiSelect
            ? multiSelectedItems.some(selectedItem => selectedItem.id === item.id)
            : dropItem?.id === item.id;
        const itemClassName = multiSelect && showCheckbox
            ? 'dropdown-label dropdown-multi-label non-hover'
            : `${selected ? 'dropdown-label2' : 'dropdown-label'} non-hover`;
        return (react_1.default.createElement("div", { key: `${item.id}_${index}`, className: itemClassName, style: styles?.bodyItem, onClick: () => handlerItemClick(item) },
            multiSelect && showCheckbox && (react_1.default.createElement("div", { className: "dropdown-multi-checkbox-wrap", onClick: event => event.stopPropagation() },
                react_1.default.createElement(CheckBox_1.CheckBoxElement, { id: item.id, checked: selected, handlerCheck: () => handlerItemClick(item), className: "dropdown-multi-checkbox", iconSize: 20 }))),
            dropOption.itemIcon.show && (react_1.default.createElement(Icon_1.default, { icon: isDesktop
                    ? dropOption.itemIcon.name
                    : selected
                        ? `${item.id}_on`
                        : `${item.id}_off`, size: dropOption.itemIcon.size, fill: selected ? dropOption.itemIcon.focus : dropOption.itemIcon.color })),
            react_1.default.createElement("p", { className: `${selected && !(multiSelect && showCheckbox) ? 'placeholder-selected placeholder2' : 'placeholder2'} overText`, style: { flex: 1, ...styles?.itemText } }, t(`${item.title}`))));
    };
    return (react_1.default.createElement("div", { ref: dropDownRef, className: `${isHeaderTitle ? '' : 'dropdown'} ${isDisable ? 'disabled' : ''} ${className} ${isMobile ? 'mobile_drop' : isTablet ? 'tablet_drop' : 'pc_drop'}`, style: { ...styles?.dropWrap, cursor: isDisable ? 'default' : 'pointer' }, onMouseDown: open ? handleClickOutside : undefined },
        react_1.default.createElement("div", { className: isHeaderTitle ? '' : 'dropdown-field', style: styles?.titleWrap, onClick: isDisable ? undefined : handlerDropDownClick },
            renderTitle,
            !isDisable && dropOption.downIcon.show && (react_1.default.createElement(Icon_1.default, { icon: dropOption.downIcon.name, className: isSidebar ? open ? 'arrow-down' : 'arrow-up' : open ? 'arrow-up' : 'arrow-down', size: dropOption.downIcon.size, stroke: dropOption.downIcon.color, fill: dropOption.downIcon.color }))),
        list && list.length > 0 && (react_1.default.createElement("div", { ref: dropDownChildRef, className: `dropdown-list ${isSidebar ? 'sidebar-dropdown-list' : ''}`, style: {
                display: open ? 'flex' : 'none',
                ...styles?.itemWrap,
            } }, list.map((item, index) => renderItem(item, index))))));
});
